export default __webpack_public_path__ + "static/media/sofi_negra.1f52c0ff.png";